import { SettingsForm } from '../components/settings-form';
import { ThemeLayout } from '../components/theme/theme-layout';

const Settings = () => (
  <ThemeLayout variant="centered">
    <SettingsForm />
  </ThemeLayout>
);

export default Settings;
